import React, { useRef } from "react";
import { PoMenu as BasePoMenu } from "@poscon/shared-frontend";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import type { Container as PixiContainer } from "pixi.js";
import { useDragging } from "hooks/useDragging";
import { setAsel, viewPositionSelector } from "~redux/slices/edstSlice";
import { sectorTrackSelector, trackFromFpIdSelector } from "~redux/slices/aircraftSlice";
import { processEramMessage } from "~redux/thunks/processEramMessage";
import { layerZIndexMap } from "~/layerZIndexMap";
import { EdstAircraftMenuProps } from "../menus/AircraftMenu";

const view = "PO_MENU";

export const PoMenu = ({ fp }: EdstAircraftMenuProps) => {
  const fpId = fp.id;
  const dispatch = useRootDispatch();
  const ref = useRef<PixiContainer>(null);
  const pos = useRootSelector((state) => viewPositionSelector(state, view));
  const { startDrag } = useDragging(ref, view);
  const track = useRootSelector((state) => trackFromFpIdSelector(state, fpId));
  const sectorTrack = useRootSelector((state) => (track ? sectorTrackSelector(state, track.id) : null));

  return fp && sectorTrack ? (
    <BasePoMenu
      ref={ref}
      fp={fp}
      sectorTrack={sectorTrack}
      pos={pos}
      startDrag={startDrag}
      closeMenu={() => dispatch(setAsel(null))}
      dispatchCommand={(command) => dispatch(processEramMessage(command, true))}
      zIndex={layerZIndexMap.prompts}
    />
  ) : null;
};
